export const oidcNEONConstants = {
  stsAuthority: process.env['REACT_APP_NEON_STS_AUTHORITY'],
  clientId: process.env['REACT_APP_NEON_CLIENT_ID'],
  clientRoot: process.env['REACT_APP_NEON_CLIENT_ROOT'],
  clientScope:
    'openid offline offline_access urn:neoncloud:projects:create urn:neoncloud:projects:read urn:neoncloud:projects:update urn:neoncloud:projects:delete',
};
